import { Injectable } from '@angular/core';
import {UsefullLinkData} from "../interfaces/usefull-link-data";
import {ImageService} from "../atoms/image/image.service";
import {InformationLink} from "../interfaces/backend/information-link";

@Injectable({
  providedIn: 'root'
})
export class InformationLinksParserService {

  constructor(
    private imageService: ImageService
  ) { }

  parseRawInformationLinks(rawLinks: InformationLink[]): UsefullLinkData[] {
    let parsedLinks: UsefullLinkData[] = [];
    for (let i = 0; i < rawLinks.length; i++) {
      let link = rawLinks[i];
      parsedLinks.push({
        image: this.imageService.mapRawImageData(link.media?.image),
        title: link.heading ?? "",
        description: link.description ?? "",
        url: link.linkUrl ?? ""
      });
    }

    return parsedLinks;

  }
}
